import { TSettlementProcParamDataTableData } from "./SettlementProcessingParametersDataTableMeta";

const settlementProcParamFakeData: TSettlementProcParamDataTableData[] = [
    {
        primaryKey: 1,
        tc: "05000",
        usage: "1",
        proc: "A0",
        entity1: "",
        entity2: "",
        entity3: "",
    },
    {
        primaryKey: 2,
        tc: "05000",
        usage: "1",
        proc: "A1",
        entity1: "",
        entity2: "",
        entity3: "",
    },
    {
        primaryKey: 3,
        tc: "05000",
        usage: "1",
        proc: "A2",
        entity1: "",
        entity2: "",
        entity3: "",
    },
    {
        primaryKey: 4,
        tc: "05000",
        usage: "1",
        proc: "I0",
        entity1: "",
        entity2: "",
        entity3: "",
    },
    {
        primaryKey: 5,
        tc: "05000",
        usage: "1",
        proc: "I1",
        entity1: "",
        entity2: "",
        entity3: "",
    },
    {
        primaryKey: 6,
        tc: "05000",
        usage: "1",
        proc: "I2",
        entity1: "",
        entity2: "",     
        entity3: "",
    },
    {
        primaryKey: 7,
        tc: "05000",
        usage: "2",
        proc: "A0",
        entity1: "",
        entity2: "",
        entity3: "",
    },
    {
        primaryKey: 8,
        tc: "05000",
        usage: "2",
        proc: "A1",
        entity1: "",
        entity2: "",
        entity3: "",
    },
    {
        primaryKey: 9,
        tc: "05000",
        usage: "2",
        proc: "A2",
        entity1: "",
        entity2: "",
        entity3: "",
    },
    {
        primaryKey: 10,
        tc: "05000",
        usage: "2",
        proc: "I0",
        entity1: "",
        entity2: "",
        entity3: "",
    },
    {
        primaryKey: 10,
        tc: "05000",
        usage: "2",
        proc: "I1",
        entity1: "",
        entity2: "",
        entity3: "",
    },
    {
        primaryKey: 10,
        tc: "05000",
        usage: "2",
        proc: "I2",
        entity1: "",
        entity2: "",
        entity3: "",
    },


];

export default settlementProcParamFakeData;